export default "__VITE_ASSET__CWvd2aeK__"